<template>
    <div v-if="backgroundColorValue && fontColorValue && lineData.text"
         :style="{backgroundColor: backgroundColorValue}">
                <div class="info-line-text" :style="{color: fontColorValue}">{{lineData.text}}</div>
    </div>
</template>

<script>
    export default {
        name: 'info-line',
        props: {
            lineData: {
                required: true,
            },
        },
        computed: {
            backgroundColorValue() {
                return this.lineData.background_color;
            },
            fontColorValue() {
                return this.lineData.font_color;
            },
        },
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/InfoLine.vue